import { FC, PropsWithChildren } from 'react';

import { IntervalDataContext, IntervalDataContextProps } from './IntervalDataContext';

export const IntervalDataProvider: FC<PropsWithChildren<IntervalDataContextProps>> = (props) => {
	return <IntervalDataContext.Provider value={props}>{props.children}</IntervalDataContext.Provider>;
};
